import React from 'react';
import { useNavigate } from 'react-router-dom';
import Register from '../components/Auth/Register';

function RegisterPage() {
  const navigate = useNavigate();

  const handleSwitchToLogin = () => {
    navigate('/login');
  };

  const handleRegisterSuccess = () => {
    navigate('/dashboard');
  };

  return (
    <div>
      <Register 
        onSwitchToLogin={handleSwitchToLogin}
        onRegisterSuccess={handleRegisterSuccess}
      />
    </div>
  );
}

export default RegisterPage;